/*-------------------------------------------------------------------------------------------------------------------
* about:设备按照ui分类函数
* author:马兆铿
* date:2018-3-9
* -------------------------------------------------------------------------------------------------------------------*/
import {showDevice} from '../../../../utils/device/deviceShow';
/*  设备按照ui分类函数
* @param {arr}list后端传来的设备列表
* @return {arr}分类后的设备列表
* */
export const deviceSort = (list) => {
  let deviceList = [...list]; // 为了方便删减，复制一次

  /*  删除加入过列表的数据
  * */
  function deleteAddedDevice() {
    deviceList = deviceList.filter(item => !item.isNeedToDelete);
  }

  //过滤不显示的设备
  deviceList.forEach((item, index) => {  //生成遥控器作为大类
    if (showDevice.checkIfNotShow(item.deviceType, item.subDeviceType)) {
      item.isNeedToDelete = true;
    }
  });
  deleteAddedDevice();

  //遥控器则生成多个遥控器作为上级，再操作
  let controllerDeviceList = [];
  deviceList.forEach((item, index) => {  //生成遥控器作为大类
    if (showDevice.irc.find(num => num === item.deviceType)) { //支持小方和allone
      controllerDeviceList.push({
        ...item,
        title: item.deviceName,
        subDeviceArr: [],
        isShow: true, //默认遥控都显示
      });
      item.isNeedToDelete = true;
    }
  });
  deleteAddedDevice();
  controllerDeviceList.forEach(controller => {  //设备归于大类之中
    controller.subDeviceTypeArr = showDevice.remote;
    deviceList.forEach((item, index) => {
      if (
        item.uid === controller.uid //uid相同的归于一个设备
        && controller.subDeviceTypeArr.find(num => num === item.deviceType) // 而且红外支持
      ) {
        controller.subDeviceArr.push(item);
        item.isNeedToDelete = true;
      }
    });
  });
  deleteAddedDevice();

  //固定的设备类型
  let fixedDeviceList = [
    {title: '插座', subDeviceTypeArr: showDevice.socket, subDeviceArr: [], isShow: false,},
    {title: '开关', subDeviceTypeArr: showDevice.switch, subDeviceArr: [], isShow: false,},
    {title: '灯光', subDeviceTypeArr: showDevice.light, subDeviceArr: [], isShow: false,},
    {title: '窗帘', subDeviceTypeArr: showDevice.curtainMoto, subDeviceArr: [], isShow: false,},
    {title: '晾衣机', subDeviceTypeArr: showDevice.hanger, subDeviceArr: [], isShow: false,},
    {title: '窗户', subDeviceTypeArr: showDevice.window, subDeviceArr: [], isShow: false,},
    {title: '空调', subDeviceTypeArr: showDevice.air, subDeviceArr: [], isShow: false,}, //剩余的全部归于此
    {title: '其它', subDeviceTypeArr: showDevice.other, subDeviceArr: [], isShow: false,}, //剩余的全部归于此
  ];

  //无上级设备的处理，为其准备固定上级
  fixedDeviceList.forEach(type => {
    type.subDeviceTypeArr.forEach(subDeviceType => {
      deviceList.forEach((item, index) => {
        if (item.deviceType === subDeviceType) {
          type.subDeviceArr.push(item);
          item.isNeedToDelete = true;
        }
      });
    });
  });
  fixedDeviceList.forEach(type => { //查看设备数量，空的类目整个都不显示
    if (type.subDeviceArr.length) type.isShow = true;
  });
  deleteAddedDevice();

  return controllerDeviceList.concat(fixedDeviceList);
};



// WEBPACK FOOTER //
// ./src/pages/Home/deviceLIst/js/deviceListSort.js